import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { WithDataFetchParams } from '@shared/redux/commons.types';

import { deleteHotSpot, getHotSpots, saveHotSpot } from './hot-spot-container/hot-spot-container.state';
import { HotSpot } from './hot-spot.types';

export interface WithHotSpots{
    hotSpots:WithDataFetchParams<HotSpot>;
}

// TODO(Pedro) REMOVE objectSelected
export const withHotSpots = connect(
    state => ({
        hotSpots: state.dashboard.hotSpots,
        objectSelected: state.data.objectSelected,
    }),
    dispatch => bindActionCreators({
        getHotSpots,
        deleteHotSpot,
        saveHotSpot,
    }, dispatch),
);
